var map = {
	"./AFBGAMING.png": "1efa",
	"./AFBSPORT.png": "39b5",
	"./AG.png": "6fe0",
	"./ALLBET.png": "28d2",
	"./BET.png": "36ac",
	"./BGLIVE.png": "53a6",
	"./BIGGAMING.png": "4f75",
	"./CHERRYGAMING.png": "c3d6",
	"./CT.png": "a90f",
	"./D88.png": "e716",
	"./DREAMGAMING.png": "94a7",
	"./EBET.png": "d81d",
	"./EVO.png": "33b9",
	"./FantasticLeague.png": "2f7f",
	"./GreyHoundRacing.png": "ccdb",
	"./HOTGRAPH.png": "09eb",
	"./HourseRacing.png": "dbca",
	"./KENO.png": "503c",
	"./N2LIVE.png": "8068",
	"./OBET.png": "177b",
	"./PRAGMATICPLAY.png": "1ea9",
	"./PREETY.png": "7d0a",
	"./PenaltyShootout.png": "38f2",
	"./RNG.png": "17bd",
	"./SA.png": "58ee",
	"./SEXYBCRT.png": "1f96",
	"./VENUS.png": "319e",
	"./WM.png": "205e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "99c1";